<!-- ========== Left Sidebar Start ========== -->

<ng-template #contentTemplate>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      <li class="menu-title">Menu</li>

      <li>
        <a routerLink="/dashboard" routerLinkActive="active" class="side-nav-link-ref">
          <i class="bx bx-home-circle"></i><span class="badge badge-pill badge-info float-right">3</span>
          <span>Dashboard</span>
        </a>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-layout"></i>
          <span>Layouts</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a (click)="changeLayout('horizontal')" href="javascript: void(0);">Horizontal</a></li>
          <li><a (click)="lightSidebar()" href="javascript: void(0);">Light Sidebar</a></li>
          <li><a (click)="compactSidebar()" href="javascript: void(0);">Compact Sidebar</a></li>
          <li><a (click)="iconSidebar()" href="javascript: void(0);">Icon Sidebar</a></li>
          <li><a (click)="boxedLayout()" href="javascript: void(0);">Boxed Layout</a></li>
          <li><a (click)="coloredSidebar()" href="javascript: void(0);">Colored Sidebar</a></li>
        </ul>
      </li>

      <li class="menu-title">Apps</li>

      <li>
        <a routerLink="/calendar" routerLinkActive="active" class="side-nav-link-ref">
          <i class="bx bx-calendar"></i>
          <span>Calendar</span>
        </a>
      </li>

      <li>
        <a routerLink="/chat" routerLinkActive="active" class="side-nav-link-ref">
          <i class="bx bx-chat"></i>
          <span class="badge badge-pill badge-success float-right">New</span>
          <span>Chat</span>
        </a>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-store"></i>
          <span>Ecommerce</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/ecommerce/products" routerLinkActive="active" class="side-nav-link-ref">Products</a></li>
          <li><a routerLink="/ecommerce/product-detail" routerLinkActive="active" class="side-nav-link-ref">Product
              Detail</a></li>
          <li><a routerLink="/ecommerce/orders" routerLinkActive="active" class="side-nav-link-ref">Orders</a></li>
          <li><a routerLink="/ecommerce/customers" routerLinkActive="active" class="side-nav-link-ref">Customers</a>
          </li>
          <li><a routerLink="/ecommerce/cart" routerLinkActive="active" class="side-nav-link-ref">Cart</a></li>
          <li><a routerLink="/ecommerce/checkout" routerLinkActive="active" class="side-nav-link-ref">Checkout</a></li>
          <li><a routerLink="/ecommerce/shops" routerLinkActive="active" class="side-nav-link-ref">Shops</a></li>
          <li><a routerLink="/ecommerce/add-product" routerLinkActive="active" class="side-nav-link-ref">Add Product</a>
          </li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-envelope"></i>
          <span>Email</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/email/inbox" routerLinkActive="active" class="side-nav-link-ref">Inbox</a></li>
          <li><a routerLink="/email/read" routerLinkActive="active" class="side-nav-link-ref">Read Email</a></li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-receipt"></i>
          <span>Invoices</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/invoices/list" routerLinkActive="active" class="side-nav-link-ref">Invoice List</a></li>
          <li><a routerLink="/invoices/detail" routerLinkActive="active" class="side-nav-link-ref">Invoice Detail</a>
          </li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-briefcase-alt-2"></i>
          <span>Projects</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/projects/grid" routerLinkActive="active" class="side-nav-link-ref">Projects Grid</a></li>
          <li><a routerLink="/projects/list" routerLinkActive="active" class="side-nav-link-ref">Projects List</a></li>
          <li><a routerLink="/projects/overview" routerLinkActive="active" class="side-nav-link-ref">Project
              Overview</a></li>
          <li><a routerLink="/projects/create" routerLinkActive="active" class="side-nav-link-ref">Create New</a></li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-task"></i>
          <span>Tasks</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/tasks/list" routerLinkActive="active" class="side-nav-link-ref">Task List</a></li>
          <li><a routerLink="/tasks/kanban" routerLinkActive="active" class="side-nav-link-ref">Kanban Board</a></li>
          <li><a routerLink="/tasks/create" routerLinkActive="active" class="side-nav-link-ref">Create Task</a></li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bxs-user-detail"></i>
          <span>Contacts</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/contacts/grid" routerLinkActive="active" class="side-nav-link-ref">User Grid</a></li>
          <li><a routerLink="/contacts/list" routerLinkActive="active" class="side-nav-link-ref">User List</a></li>
          <li><a routerLink="/contacts/profile" routerLinkActive="active" class="side-nav-link-ref">Profile</a></li>
        </ul>
      </li>

      <li class="menu-title">Pages</li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-user-circle"></i>
          <span>Authentication</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/pages/login-1" routerLinkActive="active" class="side-nav-link-ref">Login</a></li>
          <li><a routerLink="/pages/register-1" routerLinkActive="active" class="side-nav-link-ref">Register</a></li>
          <li><a routerLink="/pages/recoverpwd-1" routerLinkActive="active" class="side-nav-link-ref">Recover
              Password</a>
          </li>
          <li><a routerLink="/pages/lock-screen-1" routerLinkActive="active" class="side-nav-link-ref">Lock Screen</a>
          </li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-file"></i>
          <span>Utility</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/pages/starter" routerLinkActive="active" class="side-nav-link-ref">Starter Page</a></li>
          <li><a routerLink="/pages/maintenance">Maintenance</a></li>
          <li><a routerLink="/pages/timeline" routerLinkActive="active" class="side-nav-link-ref">Timeline</a></li>
          <li><a routerLink="/pages/faqs" routerLinkActive="active" class="side-nav-link-ref">FAQs</a></li>
          <li><a routerLink="/pages/pricing" routerLinkActive="active" class="side-nav-link-ref">Pricing</a></li>
          <li><a routerLink="/pages/404" routerLinkActive="active" class="side-nav-link-ref">Error 404</a></li>
          <li><a routerLink="/pages/500" routerLinkActive="active" class="side-nav-link-ref">Error 500</a></li>
        </ul>
      </li>

      <li class="menu-title">Components</li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-tone"></i>
          <span>UI Elements</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/ui/alerts" routerLinkActive="active" class="side-nav-link-ref">Alerts</a></li>
          <li><a routerLink="/ui/buttons" routerLinkActive="active" class="side-nav-link-ref">Buttons</a></li>
          <li><a routerLink="/ui/cards" routerLinkActive="active" class="side-nav-link-ref">Cards</a></li>
          <li><a routerLink="/ui/carousel" routerLinkActive="active" class="side-nav-link-ref">Carousel</a></li>
          <li><a routerLink="/ui/dropdowns" routerLinkActive="active" class="side-nav-link-ref">Dropdowns</a></li>
          <li><a routerLink="/ui/grid" routerLinkActive="active" class="side-nav-link-ref">Grid</a></li>
          <li><a routerLink="/ui/images" routerLinkActive="active" class="side-nav-link-ref">Images</a></li>
          <li><a routerLink="/ui/modals" routerLinkActive="active" class="side-nav-link-ref">Modals</a></li>
          <li><a routerLink="/ui/rangeslider" routerLinkActive="active" class="side-nav-link-ref">Range Slider</a></li>
          <li><a routerLink="/ui/progressbar" routerLinkActive="active" class="side-nav-link-ref">Progress Bars</a></li>
          <li><a routerLink="/ui/sweet-alert" routerLinkActive="active" class="side-nav-link-ref">Sweet-Alert</a></li>
          <li><a routerLink="/ui/tabs-accordions" routerLinkActive="active" class="side-nav-link-ref">Tabs &
              Accordions</a></li>
          <li><a routerLink="/ui/typography" routerLinkActive="active" class="side-nav-link-ref">Typography</a></li>
          <li><a routerLink="/ui/video" routerLinkActive="active" class="side-nav-link-ref">Video</a></li>
          <li><a routerLink="/ui/general" routerLinkActive="active" class="side-nav-link-ref">General</a></li>
          <li><a routerLink="/ui/colors" routerLinkActive="active" class="side-nav-link-ref">Colors</a></li>
          <li><a routerLink="/ui/image-crop" routerLinkActive="active" class="side-nav-link-ref">Image Cropper</a></li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-dropdown">
          <i class="bx bxs-eraser"></i>
          <span class="badge badge-pill badge-danger float-right">6</span>
          <span>Forms</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/form/elements" routerLinkActive="active" class="side-nav-link-ref">Form Elements</a></li>
          <li><a routerLink="/form/validation" routerLinkActive="active" class="side-nav-link-ref">Form Validation</a>
          </li>
          <li><a routerLink="/form/advanced" routerLinkActive="active" class="side-nav-link-ref">Form Advanced</a></li>
          <li><a routerLink="/form/editor" routerLinkActive="active" class="side-nav-link-ref">Form Editors</a></li>
          <li><a routerLink="/form/uploads" routerLinkActive="active" class="side-nav-link-ref">Form File Upload</a>
          </li>
          <li><a routerLink="/form/repeater" routerLinkActive="active" class="side-nav-link-ref">Form Repeater</a></li>
          <li><a routerLink="/form/wizard" routerLinkActive="active" class="side-nav-link-ref">Form Wizard</a></li>
          <li><a routerLink="/form/mask" routerLinkActive="active" class="side-nav-link-ref">Form Mask</a></li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-list-ul"></i>
          <span>Tables</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/tables/basic" routerLinkActive="active" class="side-nav-link-ref">Basic Tables</a></li>
          <li><a routerLink="/tables/advanced" routerLinkActive="active" class="side-nav-link-ref">Advanced Table</a>
          </li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bxs-bar-chart-alt-2"></i>
          <span>Charts</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/charts/apex" routerLinkActive="active" class="side-nav-link-ref">Apex charts</a></li>
          <li><a routerLink="/charts/chartjs" routerLinkActive="active" class="side-nav-link-ref">Chartjs Chart</a></li>
          <li><a routerLink="/charts/chartist" routerLinkActive="active" class="side-nav-link-ref">Chartist Chart</a>
          </li>
          <li><a routerLink="/charts/echart" routerLinkActive="active" class="side-nav-link-ref">E - Chart</a></li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-aperture"></i>
          <span>Icons</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/icons/boxicons" routerLinkActive="active" class="side-nav-link-ref">Boxicons</a></li>
          <li><a routerLink="/icons/materialdesign" routerLinkActive="active" class="side-nav-link-ref">Material
              Design</a></li>
          <li><a routerLink="/icons/dripicons" routerLinkActive="active" class="side-nav-link-ref">Dripicons</a></li>
          <li><a routerLink="/icons/fontawesome" routerLinkActive="active" class="side-nav-link-ref">Font awesome</a>
          </li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-map"></i>
          <span>Maps</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li><a routerLink="/maps/google" routerLinkActive="active" class="side-nav-link-ref">Google Maps</a></li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" class="has-arrow">
          <i class="bx bx-share-alt"></i>
          <span>Multi Level</span>
        </a>
        <ul class="sub-menu" aria-expanded="true">
          <li><a href="javascript: void(0);">Level 1.1</a></li>
          <li><a href="javascript: void(0);" class="has-arrow">Level 1.2</a>
            <ul class="sub-menu" aria-expanded="true">
              <li><a href="javascript: void(0);">Level 2.1</a></li>
              <li><a href="javascript: void(0);">Level 2.2</a></li>
            </ul>
          </li>
        </ul>
      </li>

    </ul>
  </div>
</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
  <perfect-scrollbar [config]="configData">
    <div *ngIf="!isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div *ngIf="isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </perfect-scrollbar>

</div>
<!-- Left Sidebar End -->
